import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useAuth } from "../../Context/AuthContext";
import { ClipLoader } from "react-spinners";

const LoginModel = ({
  showLoginModal,
  handleCloseModal,
  handleRegisterClick,
  handleForgotPasswordOpen,
}) => {
  // const { loadUserData } = useContext(UserProfileContext);
  // const { fetchMyOrders, orderHistory } = useContext(MyOrderContext);
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { handleLoginSubmit } = useAuth(); // Get the login function from AuthContext
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  // const [pathName, setPathName] = useState("");
  const Navigate = useNavigate();
  const location = useLocation();

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  // setPathName(location.pathname);
  const handleSubmit = (e) => {
    e.preventDefault();
    handleLoginSubmit(email, password, handleCloseModal, setEmail, setPassword);
  };

  if (!showLoginModal) return null;

  return (
    <>
      {/* Background Overlay */}
      <div className="overlay-custom" onClick={handleCloseModal}></div>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog p-4 modal-dialog-centered modal-lg justify-content-center">
          <div className="modal-content p-0 border-radius-none">
            <div className="modal-header px-md-4">
              <h5 className="modal-title">{t("Login")}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleCloseModal}
              ></button>
            </div>
            <div className="modal-body px-md-4 col-md-12">
              <form className="text-start" onSubmit={handleSubmit}>
                <div className="form-group mb-2">
                  <label className="form-label" htmlFor="email">
                    {t("Email")}
                  </label>
                  <input
                    type="email"
                    id="email"
                    placeholder={t("Enter-your-email")}
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <div className="mb-1 position-relative">
                    <label htmlFor="password" className="form-label">
                      {t("Password")}
                    </label>
                    <input
                      type={passwordVisible ? "text" : "password"}
                      className="form-control"
                      id="password"
                      placeholder={t("Enter-your-Password")}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <span
                      className="position-absolute top-70 end-0 translate-middle-y me-3"
                      style={{ cursor: "pointer" }}
                      onClick={togglePasswordVisibility}
                    >
                      {passwordVisible ? (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      ) : (
                        <FontAwesomeIcon icon={faEye} />
                      )}
                    </span>
                  </div>
                  {/* Forgot Password Link */}
                  <div className="mb-3 form-group text-end">
                    <Link
                      to="#"
                      className="text-start  px-0"
                      onClick={handleForgotPasswordOpen}
                    >
                      {t("Forgot Password?")}
                    </Link>
                  </div>
                </div>

                {/* Error message */}
                {error && <div className="alert alert-danger">{error}</div>}

                <div className="form-check mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="rememberMe"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="rememberMe">
                    {t("Remember me")}
                  </label>
                </div>

                <div className="form-group mt-3 col-6 col-md-3">
                  <button
                    type="submit"
                    className="btn btn-green-theme"
                    disabled={loading}
                  >
                    {loading ? (
                      <div>
                        <ClipLoader
                          color={"#000"}
                          loading={loading}
                          size={24}
                        />
                      </div>
                    ) : (
                      t("Login")
                    )}
                  </button>
                </div>
              </form>

              {/* Register Link */}
              <div className="mt-0 pt-3 text-start text-md-center">
                <p className="mb-0">
                  {t("Don't-have-an-account?")}{" "}
                  <Link to="#" onClick={handleRegisterClick}>
                    {t("Register")}
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginModel;
